import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Input } from "../forms";
import Button from "../Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getProviderCreditTransactions,
  submitPassCode,
} from "../../features/user/userSlice";
import {
  getClientVisits,
  getClientActivity,
} from "../../features/clients/clientSlice";
import Icon from "../Icon";
import { getUserFromLocalStorage } from "../../utils/localstorage";

const PassModal = ({
  openFlancePassModal,
  setOpenFlancePassModal,
  containerClassName,
  storedData,
  setOpenVerificationStatus,
  setVerificationStatus,
  setVerifiedClientName,
  setVerificationErrorMessage,
  clientType,
  setServiceDetails,
}) => {
  const { passDetails, submitClientsManuallyLoading } = useSelector(
    (store) => store.user
  );

  // getBranch && getBranch === String ? JSON.parse(getBranch) : null;

  const [passInfo, setPassInfo] = useState("");
  const user = getUserFromLocalStorage();
  const [categories, setCategories] = useState(user?.data?.categories);
  const branch = localStorage.getItem(`${user?.data?.providerId}branch`);
  const [searchService, setSearchService] = useState("");
  console.log(categories);

  


  // Parse branch data and extract service offerings
  const parsedBranch = branch ? JSON.parse(branch) : null;
  // console.log("Parsed", parsedBranch);
  const [services, setServices] = useState(() => {
    if (parsedBranch?.serviceOfferings) {
      // Flatten the nested service offerings structure
      const flattenedServices = [];
      parsedBranch.serviceOfferings.forEach((category) => {
        category.serviceOfferings.forEach((service) => {
          flattenedServices.push({
            id: service.id.toString(),
            label: service.name,
          });
        });
      });
      return flattenedServices;
    }
    return null;
  });

  const filteredServices = searchService.length > 1 ? services?.filter((service) =>
    service.label.toLowerCase().includes(searchService.toLowerCase())
  ) : services;

  // Filter out spa category if services is null
  // TODO: stop filtering out spa category if services is null because onboarding should take care of this (as per spas that do not have sevices won't be marked as onboarded)
  const [filteredCategories, setFilteredCategories] = useState([]);
  useEffect(() => {
    if (services === null) {
      // If services is null, filter out the spa category
      setFilteredCategories(
        categories?.filter((cat) => cat.category.toLowerCase() !== "spa")
      );
    } else {
      // Otherwise, use all categories
      setFilteredCategories(categories);
    }
  }, [categories, services]);

  console.log(filteredCategories, "filter");

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // Set initial selected category after filtering
  useEffect(() => {
    if (filteredCategories.length > 0 && !selectedCategoryId) {
      setSelectedCategoryId(filteredCategories[0]?.id);
    }
  }, [filteredCategories, selectedCategoryId]);

  const [showServices, setShowServices] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const dispatch = useDispatch();
  const submitCode = () => {
    dispatch(
      submitPassCode({
        accessCode: passInfo,
        visitTimestamp: new Date(),
        providerBranchId: storedData?.id,
        categoryId: selectedCategoryId,
        serviceId: selectedServiceId,
      })
    ).then((res) => {
      setOpenFlancePassModal(false);
      setOpenVerificationStatus(true);

      if (res?.type === "user/submitPassCode/fulfilled") {
        setVerificationStatus("ok");
        // Format the name as "Firstname .L"
        const firstName = res.payload?.data?.firstName || "";
        const lastInitial = res.payload?.data?.lastName?.charAt(0) || "";
        const formattedName = `${firstName} .${lastInitial}`;
        setVerifiedClientName(formattedName);
        dispatch(getProviderCreditTransactions());
        dispatch(getClientVisits({ branch: storedData?.id }));
        dispatch(
          getClientActivity({
            clientType,
            page: 0,
            numPerPage: 7,
            branch: storedData?.id,
          })
        );
      } else {
        // Handle different error cases based on the response
        console.log('res', res?.payload)
        if (res?.payload === "Oops, This Passcode has Expired") {
          setVerificationStatus("expired");
        } else if (res?.payload === "Oops, This passcode is Invalid") {
          setVerificationStatus("invalid");
          setServiceDetails({catgoryId: selectedCategoryId, serviceId: selectedServiceId})
          setVerificationErrorMessage(res?.payload);
        } else {
          setVerificationStatus("other");
          setVerificationErrorMessage(res?.payload);
        }
      }
      setPassInfo("");
    });
  };
  return (
    <Modal
      handleClose={() => {
        setOpenFlancePassModal(false);
      }}
      title={"Enter passcode"}
      show={openFlancePassModal}
      isModalBig={false}
      containerClassName="addClients--modal"
    >
      <div className="w-full gap-[20px] flex flex-col justify-start items-start">
        <div className="w-full flex flex-col justify-start items-start gap-[6px]">
          {filteredCategories?.length > 1 && (
            <p className="text-[14px] font-400 leading-[150%] text-[#000B14]">
              Service Category
            </p>
          )}
          <div className="flex flex-row justify-start items-start gap-[20px]">
            {filteredCategories?.length > 1 && (
              <>
                {filteredCategories?.map((category, index) => (
                  <div
                    key={category.id}
                    className="cursor-pointer flex items-center gap-[6px] p-[12px] h-[31px] border border-[#E4E7EC] rounded-full"
                  >
                    <input
                      id={category.id}
                      type="radio"
                      name={category.category}
                      checked={selectedCategoryId === category.id}
                      onChange={() => {
                        setSelectedCategoryId(category.id);
                      }}
                      className="w-4 h-4 text-[#005397] bg-gray-100 border-gray-300 cursor-pointer"
                    />
                    <label
                      htmlFor={category.id}
                      className={`font-500 text-[14px] cursor-pointer ${
                        selectedCategoryId === category.id
                          ? "text-[#005397]"
                          : "text-[#5C6368]"
                      }`}
                    >
                      {category.category}
                    </label>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>

        {(categories
          ?.find((cat) => cat?.id === selectedCategoryId)
          ?.category?.toLowerCase() === "spa" ||
          categories
            ?.find((cat) => cat?.id === selectedCategoryId)
            ?.category?.toLowerCase() === "lab") && (

          <div className="w-full flex flex-col justify-start items-start gap-[6px]">
            <p className="text-[14px] font-400 leading-[150%] text-[#000B14]">
              Select a Service
            </p>
            {services?.length > 0 ? (
            <div className={"relative flex w-full flex-col items-start justify-start border border-[#D3D3D399] rounded-lg cursor-pointer"}>
              <div
                onClick={() => setShowServices(!showServices)}
                className={`flex flex-row items-center justify-between px-[24px] py-[18.5px] w-full h-[61px]  ${
                  showServices ? "border-b border-[#D3D3D399]" : ""
                }`}
              >
                <div className="flex flex-col items-start justify-start gap-[10px]">
                  <span
                    className={`text-[#5C6368] opacity-60 font-400 leading-[100%] ${
                      selectedServiceId && !showServices
                        ? "text-[12px]"
                        : "text-[16px]"
                    }`}
                  >
                    Select a Service
                  </span>
                  {selectedServiceId && !showServices && (
                    <span className="text-[#000B14] font-400 text-[16px] leading-[100%] capitalize">
                      {services
                        ?.find((s) => s.id === selectedServiceId)
                        ?.label.toLowerCase()}
                    </span>
                  )}
                </div>
                <Icon
                  id="drop-down"
                  width={24}
                  height={24}
                  className={`transition-transform ${
                    showServices ? "rotate-180" : ""
                  }`}
                />
              </div>
              {showServices && (
                <div className="rounded-lg w-full flex flex-col items-start justify-start px-[20px] py-[16px] gap-[12px]">
                  <div className="flex flex-row items-center justify-start gap-[12px] bg-[#F2F4F7] rounded-[8px] p-[12px] w-full">
                    <Icon id="search-services" width={17} height={17} />
                    <input
                      type="text"
                      placeholder="Search Service"
                      className="bg-transparent outline-none font-[400] text-[16px] leading-[100%] text-[#000000] w-full"
                      value={searchService}
                      onChange={(e) => setSearchService(e.target.value)}
                    />
                  </div>
                  {filteredServices?.length > 0 ? (
                    <ul className="flex flex-col items-start justify-start gap-[12px] max-h-[200px] scroll-bar overflow-y-scroll">
                  {filteredServices?.map((service) => (
                    <li key={service.id}>
                      <div className="flex items-center justify-start gap-[8px]">
                        <input
                          id={`spa-service-${service.id}`}
                          type="checkbox"
                          checked={selectedServiceId === service.id}
                          onChange={() => {
                            setSelectedServiceId(service.id);
                          }}
                          className="w-4 h-4 cursor-pointer text-[#005397] border border-[#D3D3D399] rounded-[4px]"
                        />
                        <label
                          htmlFor={`spa-service-${service.id}`}
                          className="text-[14px] font-400 leading-[20px] text-[#5C6368] capitalize"
                        >
                          {service?.label.toLowerCase()}
                        </label>
                      </div>
                    </li>
                  ))}
                  </ul>
                  ) : (
                    <div className='flex flex-col w-full justify-center items-center gap-[6px]'>
                      <span className="text-[14px] font-[600] leading-[100%] text-[#344054] capitalize">
                      Service not found
                      </span>
                      <span className="text-[12px] font-[400] leading-[100%] text-[#344054] ">
                      No matching services found. Try another search
                      </span>
                      <span className="text-[14px] font-600 leading-[100%] text-[#005397] underline cursor-pointer" onClick={() => setSearchService("")}>
                      Show all services
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
            ):(
              <div className={"flex w-full flex-col items-center justify-center border border-[#D3D3D399] rounded-lg p-[20px] gap-[6px] h-[90px]"}>
                <span className="text-[14px] font-[600] leading-[100%] text-[#344054] text-center">
                No service available in this branch
                </span> 
                <span className="text-[12px] font-[400] leading-[100%] text-[#344054] text-center">
                Switch branch to log visit
                </span>
              </div>
            )}
          </div>
         
        )}

        <div className="w-full flex flex-col justify-start items-start gap-[6px]">
          <p className="text-[14px] font-400 leading-[150%] text-[#000B14]">
            Enter a passcode to verify it
          </p>
          <Input
            className={"custom-height "}
            isFloatingLabel={false}
            value={passInfo}
            onChange={(e) => setPassInfo(e.target.value)}
            onFocus={() => setShowServices(false)}
          />
        </div>
        <Button
          variant="primary"
          type="submit"
          className="mt-[10px]"
          placeholder={"Enter passcode"}
          placeHolder={"Enter passcode"}
          disabled={passInfo === "" || submitClientsManuallyLoading}
          block
          // disabled={isLoading}
          onClick={() => submitCode()}
        >
          {submitClientsManuallyLoading ? "Verifying..." : "Verify code"}
        </Button>
      </div>
    </Modal>
  );
};

export default PassModal;
